import React from "react";
import { getAgencywiseApplicantData } from "../../services/pendingService";
import { Container, Form, Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import { CSVLink } from "react-csv";
import { Button } from "reactstrap";
import dowanload_csv from "../../assets/images/icon/downloadcsv.svg";
import AgencyApplicantable from "../Dashboard/AgencyApplicantable";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import calender_icon from "../../assets/images/icon/calender.svg";
import DatePicker from "react-datepicker";
import { checkPermissionStatus } from "helpers/utils";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import debounce from "lodash.debounce"; // Import debounce

///////rohit-code//////

function AgencyWiseApplication(props) {
  const { t } = useTranslation();
  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [query, setQuery] = useState("");
  const [location, setLocation] = useState("");
  const [skills, setSkills] = useState("");
  const [searchInitiated, setSearchInitiated] = useState(false);

  // Fetch Listing Data
  useEffect(() => {
    getApplicantData();
    document.title = "NeuroTal - Positions vs Applications";
  }, []);

  const clearFilters = () => {
    setQuery("");
    setStartDate("");
    setEndDate("");
    setLocation("");
    setSkills("");
    getApplicantData();
  };

  const getApplicantData = async () => {
    setLoading(true);
    await getAgencywiseApplicantData({})
      .then(res => {
        let newData = res?.data?.map(el => {
          el = {
            ...el,
            ...el?.counts,
          };
          return el;
        });
        console.log(newData,"newData")
        setDataList(newData || []);
        setLoading(false);
      })
      .catch(err => {
        let errorMsg = JSON.stringify(err?.response?.message);
        setLoading(false);
        toast.error(errorMsg || t(`Position Application.Something Went Wrong`));
      });
  };

  const handleSearch = async () => {
    if (!query && !startDate && !endDate) {
      toast.error(t(`Position Application.Please Add Search Filters`));
      return false;
    }
    if (startDate && !endDate) {
      toast.error(t(`Position Application.Please Enter End Date`));
      return false;
    }
    if (!startDate && endDate) {
      toast.error(t(`Position Application.Please Enter Start Date`));
      return false;
    }
    if (startDate > endDate) {
      toast.error(t(`Position Application.Start Date Cannot Exceed End Date`));
      return false;
    }
    setLoading(true);
    let payload = {
      jobTitle: query?.trim(),
      startDate: startDate,
      endDate: endDate,
      location: location,
      skills: skills,
    };
    await getAgencyApplicantData(payload)
      .then(res => {
        let newData = res?.data?.data?.map(el => {
          el = {
            ...el,
            ...el?.counts,
          };
          return el;
        });
        setDataList(newData || []);
        setLoading(false);
        toast.success(t(`Position Application.Data Fetched Successfully`));
      })
      .catch(err => {
        let errorMsg = JSON.stringify(err?.response?.message);
        setLoading(false);
        toast.error(errorMsg || t(`Position Application.Something Went Wrong`));
      });
  };
  // The debounce function will be called when the user stops typing.
  const debouncedSearch = debounce(async query => {
    if (query) {
      setLoading(true);
      let payload = {
        jobTitle: query?.trim(),
        startDate: startDate,
        endDate: endDate,
        location: location,
        skills: skills,
      };
      await getAgencyApplicantData(payload)
        .then(res => {
          let newData = res?.data?.data?.map(el => {
            el = {
              ...el,
              ...el?.counts,
            };
            return el;
          });
          setDataList(newData || []);
          setLoading(false);
        })
        .catch(err => {
          let errorMsg = JSON.stringify(err?.response?.message);
          setLoading(false);
          toast.error(
            errorMsg || t(`Position Application.Something Went Wrong`)
          );
        });
    } else {
      getApplicantData();
    }
  }, 500); // 500ms delay
  const handleSearchInputChange = e => {
    const value = e.target.value;
    setQuery(value);
    debouncedSearch(value); // Call the debounced search function
  };

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);
  const [inputTypeStart, setInputTypeStart] = useState("text");
  const [inputTypeEnd, setInputTypeEnd] = useState("text");

  
  useEffect(() => {
    // Add the class to the body when the component mounts
    document.body.classList.add("my-body-class");

    // Optionally, clean up by removing the class when the component unmounts
    return () => {
      document.body.classList.remove("my-body-class");
    };
  }, []);

  if (!checkPermissionStatus("position-application", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">
          {t(`Position Application.Access Denied`)}
        </h4>
      </div>
    );
  }

  return (
     <>
       <div className="pending-list-page feedbacks  departmentpage">
         <div className="tab-content" id="pills-tabContent">
           <div
             className="tab-pane fade show active"
             id="pills-home"
             role="tabpanel"
             // aria-labelledby="pills-home-tab"
           >
             <div className="joblist-container create-vacancy main-pages-s application-posiiton">
               <Row className="mb-3 align-items-center">
                 <Col lg="6" md="6" className="Joblist-column">
                   <Link to="/dashboard">
                     <h5 className="text-uppercase heading-one mbile-bottom-spce">
                       <img src={arrow_btn} alt="arrow_btn" />
                       {t(`Recruiter_Report_Title.Form_Title`)}
                     </h5>
                   </Link>
                 </Col>
               </Row>
             </div>
 
             {/* <div className="outerTab-box-wrapper below-vacancy  positon-app  applicationcard-tables posotionsapp"> */}
             <div className="outerTab-box-wrapper applicationcard-table">
               <div className="franchise-list-page region-list-page aploc posapplication">
                 <div className="form-details-sections mt-3">
                   <div className="filter-wrapper filtersa gap-2 d-flex justify-content-between align-items-center">
                     <div className="filter-wrapper  gap-2 d-flex align-items-center">
          
 
                       {checkPermissionStatus(
                         "agency-application",
                         "downloadcsv"
                       ) && (
                         <div class="single-filter-box d-flex align-items-center">
                           <CSVLink
                             data={dataList}
                             headers={[
                               {
                                 key: "name",
                                 label: t(`Recruiter_Report_Title.Recruiter_Title`),
                               },
                               {
                                 key: "totalApplicants",
                                 label: t(
                                   `Position Application.Total Applicants`
                                 ),
                               },
                              
                               {
                                 key: "status_breakdown.pending",
                                 label: t(`Position Application.Pending`),
                               },
                               {
                                 key: "status_breakdown.screening",
                                 label: t(
                                   `Position Application.Shortlisted Q&A`
                                 ),
                               },
                               {
                                 key: "status_breakdown.scheduled",
                                 label: t(
                                   `Position Application.Shortlisted F2F`
                                 ),
                               },
                               {
                                 key: "status_breakdown.selected",
                                 label: t(`Position Application.Selected`),
                               },
                               {
                                 key: "status_breakdown.onboarding",
                                 label: t(`Position Application.Onboard`),
                               },
                               {
                                 key: "status_breakdown.hold",
                                 label: t(`Position Application.On Hold`),
                               },
                               {
                                 key: "status_breakdown.rejected",
                                 label: t(`Position Application.Rejected`),
                               },
                             ]}
                             filename={`Position-Application.csv`}
                             id="downloadCSV"
                           >
                             <div className="take-text">
                               <Button color="info" outline>
                                 <img src={dowanload_csv} alt="Download" />{" "}
                                 {t(`Position Application.Download CSV`)}
                               </Button>
                             </div>
                           </CSVLink>
                         </div>
                       )}
                     </div>
                   </div>
                 </div>
                 <div className="text-center">
                   {/* <VacancyTable2 /> */}
 
                   {loading ? (
                     <FontAwesomeIcon
                       icon={faSpinner}
                       className="fa-spin mt-5"
                       style={{ height: "70px" }}
                     />
                   ) : (
                     <AgencyApplicantable
                       type={"allList"}
                       data={dataList || []}
                       disableViewAll={true}
                     />
                   )}
                 </div>
               </div>
             </div>
           </div>
         </div>
       </div>
     </>
   );
}

export default AgencyWiseApplication;
